<div class="progress" *ngIf="Steps.length">
  <div *ngFor="let step of Steps; index as i"
    class="progress-bar"
    [ngClass]="{
      'progress-bar-success': step.state == ProgressState.Completed,
      'progress-bar-striped': step.state != ProgressState.Completed,
      'progress-bar-gray': step.state == ProgressState.Pending,
      'progress-bar-info': step.state == ProgressState.InProgress || step.state == ProgressState.Processing,
      'active': step.state == ProgressState.Processing
    }"
    [ngStyle]="{'width': (100 / Count).toString() + '%' }">
    <span>{{ i + 1 }}. {{ step.title }}</span>
  </div>
</div>
